/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ProfileNoteCreate {
  /**
     * @minLength 1
     * @maxLength 10000
     */
  content: string;
  parent_note_id?: string | null;
  source_search_id?: string | null;
}
